import(/* webpackMode: "eager" */ "/app/src/app/(legal)/privacy/page.tsx");
